import { usePlausibleContext } from '@/shared/PlausibleAnalytics/PlausibleAnalytics';
import { PlausibleEvent } from '@/v2/domains/Analytics/types/common';

type TrackEventParams = (
  event: PlausibleEvent,
  props?: Record<string, unknown>
) => void;

export default function useTrackPlausibleEvent(): TrackEventParams {
  const { actions } = usePlausibleContext();

  const trackEvent = (
    event: PlausibleEvent,
    props?: Record<string, unknown>
  ) => {
    actions.sendPlausibleEvent(event, props);
  };

  return trackEvent;
}
